/**
 * Multi-flow events require an event-slot context before live toggle or player pairing
 * (backend resolves scoped PLAN binding per slot).
 */
export function requiresEventSlotForLiveBinding({
  multiFlow,
  eventSlotId,
}: {
  multiFlow?: boolean;
  eventSlotId?: string | null;
}): boolean {
  return Boolean(multiFlow) && !eventSlotId;
}
